import { httpRequest } from '@/utils/HttpRequest'

interface IToday {
    distinguishNum: number // 2 识别
    filterNum: number // -1g 过滤
    releaseNum: number // 1  发布
    signNum: number // 0 标记
}

export interface IKeyWordsPieType {
    map: object
    name: string
    value: number
}

class HomeService {
    // 设置管理
    async set(params: { userCode: string }) {
        const apiUrl = `/assets/setUp/findByUserCode`
        return await httpRequest.post<any[]>(apiUrl, params)
    }
    async setUpdate(details: any) {
        const apiUrl = `/assets/setUp/update`
        return await httpRequest.post<boolean>(apiUrl, details)
    }
    //资产总数统计
    async allCount() {
        const apiUrl = `/assets/statistics/statisticsCount1`
        return await httpRequest.post<any>(apiUrl, {})
    }
    //资产总数统计
    async statisticsCount() {
        const apiUrl = `/assets/statistics/statisticsCount`
        return await httpRequest.post<any>(apiUrl, {})
    }
    //部门使用占比
    async useCount() {
        const apiUrl = `/assets/statistics/statisticsByDept`
        return await httpRequest.post<any>(apiUrl, {})
    }
    //待办事项
    async loadWait(value) {
        const apiUrl = `/assets/applyProcess/todo`
        return await httpRequest.post<any>(apiUrl, value)
    }
    //部门使用占比
    async statusCount() {
        const apiUrl = `/assets/statistics/statisticsRatio`
        return await httpRequest.post<any>(apiUrl, {})
    }
    //柱状图使用占比
    async zhuzhunagtu() {
        const apiUrl = `/assets/statistics/statisticsType`
        return await httpRequest.post<any>(apiUrl, {})
    }

    //访问量-每季度
    async visitQuarterly(orgCode: string) {
        const apiUrl = `/ebc/log/visitQuarterly?orgCode=${orgCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    //访问量-每年
    async visitYearly(orgCode: string) {
        const apiUrl = `/ebc/log/visitYearly?orgCode=${orgCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    //新增管理公司统计-每月
    async orgInsertMonthly() {
        const apiUrl = `/ebc/log/orgInsertMonthly`
        return await httpRequest.get<any>(apiUrl)
    }
    //新增管理公司统计-每季度
    async orgInsertQuarterly() {
        const apiUrl = `/ebc/log/orgInsertQuarterly`
        return await httpRequest.get<any>(apiUrl)
    }
    //新增管理公司统计-每年
    async orgInsertYearly() {
        const apiUrl = `/ebc/log/orgInsertYearly`
        return await httpRequest.get<any>(apiUrl)
    }
    //名片新增分组统计-每月
    async groupInsertMonthly() {
        const apiUrl = `/ebc/log/groupInsertMonthly`
        return await httpRequest.get<any>(apiUrl)
    }
    //名片新增分组统计-季度
    async groupInsertQuarterly() {
        const apiUrl = `/ebc/log/groupInsertQuarterly`
        return await httpRequest.get<any>(apiUrl)
    }
    //名片新增分组统计-每年
    async groupInsertYearly() {
        const apiUrl = `/ebc/log/groupInsertYearly`
        return await httpRequest.get<any>(apiUrl)
    }
    //分享次数-每月
    async shareMonthly(orgCode: string) {
        const apiUrl = `/ebc/log/shareMonthly?orgCode=${orgCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    //分享次数-每季度
    async shareQuarterly(orgCode: string) {
        const apiUrl = `/ebc/log/shareQuarterly?orgCode=${orgCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    //分享次数-每年
    async shareYearly(orgCode: string) {
        const apiUrl = `/ebc/log/shareYearly?orgCode=${orgCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    async page(searchVo: any) {
        const apiUrl = '/assets/assets/stock/page'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
}
export const homeService = new HomeService()
